import _toConsumableArray from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
var e = [],
  a = function a(e) {
    return new RegExp(e.replace(/\*/g, ".*") + "$");
  },
  r = function r(_r) {
    e = _r.split(/[\s,]+/).map(a);
  };
var s = function s(a, r, _s) {
    for (var _len = arguments.length, l = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
      l[_key - 3] = arguments[_key];
    }
    for (var _n = e.length; _n--;) if (e[_n].test(a)) return r({
      name: a,
      level: _s,
      messages: l
    });
  },
  l = function l(e) {
    var a = "";
    var r = console["fatal" === e.level ? "error" : e.level];
    if (e.name && (a += "[".concat(e.name, "] ")), "object" == typeof e.messages[0]) r.apply(void 0, [a].concat(_toConsumableArray(e.messages)));else {
      r.apply(void 0, [a + e.messages.shift()].concat(_toConsumableArray(e.messages)));
    }
  },
  n = function n(e, a) {
    return {
      fatal: s.bind(0, e, a = a || l, "fatal"),
      error: s.bind(0, e, a, "error"),
      warn: s.bind(0, e, a, "warn"),
      debug: s.bind(0, e, a, "debug"),
      info: s.bind(0, e, a, "info"),
      log: s.bind(0, e, a, "log")
    };
  },
  o = n(""),
  t = o.fatal,
  g = o.error,
  i = o.warn,
  f = o.debug,
  b = o.info,
  d = o.log;
export { f as debug, l as default_reporter, n as diary, r as enable, g as error, t as fatal, b as info, d as log, i as warn };